import { dayPlanDtoSchema, type DayPlanDto } from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

export class PlannerResource {
  constructor(private readonly http: HttpClient) {}

  today(signal?: AbortSignal): Promise<DayPlanDto> {
    return this.http.request({
      method: 'GET',
      path: '/planner/today',
      responseSchema: dayPlanDtoSchema,
      signal,
    });
  }

  run(signal?: AbortSignal): Promise<DayPlanDto> {
    return this.http.request({
      method: 'POST',
      path: '/planner/run',
      responseSchema: dayPlanDtoSchema,
      signal,
    });
  }

  quickTodo(title: string, signal?: AbortSignal): Promise<DayPlanDto> {
    return this.http.request({
      method: 'POST',
      path: '/planner/quick-todo',
      body: { title },
      responseSchema: dayPlanDtoSchema,
      signal,
    });
  }
}
